/** Copy-pasted from customer-data-sidebar
 *  https://git.hubteam.com/HubSpot/customer-data-sidebar/blob/master/static/js/universal/context/PermissionsContext.js
 */

import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

/**
 * Context for providing permission information on CrmObjects, both user and hubspot defined
 *
 * @param {object} value                          the context value
 * @param {Boolean} value.canView                 whether or not the current user can view the subject record of the current page
 * @param {Boolean} value.canEditSubject          whether or not the current user can edit the subject record of the current page
 * @param {Boolean} value.canDeleteSubject        whether or not the current user can delete the subject record of the current page
 * @param {Boolean} value.readOnly                whether or not the sidebar is in read-only mode
 * @param {String []} value.scopes                array of scopes the current user has
 * @param {Function} value.getPropertyPermission  callback that can be used to determine the permission level of a property
 * @param {String []} value.gates                 array of gates that the current user is ungated foro
 * @param {AuthedUser} value.user                 the current user
 *
 * @param {object} options
 * @param {String []} options.objectOwnerIds    array of the object's owners' ids, optional and mostly used for "edit owned" permissions
 * @param {String []} options.objectTeamIds     array of the objects teams' ids, optional and mostly used for "edit owned" permissions
 * @param {object} options.objectTypeId         the type of the object the permissions check is for
 *
 * @param {object} options
 * @param {String} options.objectType           the type of the object to check create permissions for
 */

export const PermissionsContext = /*#__PURE__*/createContext({});
export const PermissionsContextPropType = PropTypes.shape({
  canView: PropTypes.bool.isRequired,
  canEditSubject: PropTypes.bool.isRequired,
  canDeleteSubject: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  scopes: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  getPropertyPermission: PropTypes.func.isRequired,
  gates: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  user: PropTypes.object
});
export const usePermissionsContext = () => useContext(PermissionsContext);